import { lime, purple, green, grey } from "@mui/material/colors";
// Propriétés du theme par defaut : https://mui.com/material-ui/customization/default-theme/#explore
//
// Les couleurs du theme Material UI sont réparties comme décrit si-dessous.
// Elles peuvent être éxprimées par les valeurs standard de Material UI.
// Couleurs standard Material UI : https://mui.com/material-ui/customization/color/#color-palette
//
import { env } from '../env';
// Il est également possible de les éxprimer par leur valeur RGB en hexa-décimal
// par ex : primary: { main: "#f4b25a" }
//
// primary :  - Barre de titre
//            - Plots du fil d'Ariane
//            - Tuiles du planning
//            - Plot 'actif' du calendrier
//            - Boutons d'action (Confirmer, Valider, Revenir à l'accueil)
//
// background: default  - arriere plan de la page (root)
//             paper    - couleur de fond des encarts (lieu, praticien ...)
//                        et des plots du calendrier

export const styledTheme = {
  palette: {
        primary: { main: env.REACT_APP_THEME_PRIMARY },
        background: {
          // paper: purple[300],
          // default: "#EDEDED",
            default: env.REACT_APP_THEME_BACKGROUND,
            paper: env.REACT_APP_THEME_SECONDARY
        },
        titleButton: { main: env.REACT_APP_TITLE_BUTTON },
        cardButton: { main: env.REACT_APP_CARD_BUTTON },
  },
};

